import React from 'react';
// @ts-ignore
import Loading from '../../../imgs/loading.svg';

export default function WaitJsLoading() {
  return (
    <div className="zp_waitJsLoading">
      <img src={Loading} alt="" />
    </div>
  );
}
